import coinswap from "../assets/images/exchange.png";
import tracking from "../assets/images/tracking.png";
import fee from "../assets/images/fee.png";
import secure from "../assets/images/secure.png";
import commission from "../assets/images/commission.png";
import process from "../assets/images/digital.png";

const TX_PROGRESS = {
  CANCELLED: {
    value: "Cancelled",
    progressCompleted: 100,
    progressColor: "!bg-error",
  },
  COMPLETED: {
    value: "Completed",
    progressCompleted: 100,
    progressColor: "!bg-success",
  },
  IN_TRANSIT: {
    value: "In Process",
    progressCompleted: 35,
    progressColor: "!bg-inProcess",
  },
  ASSIGNED_TO_PROCESSING: {
    value: "Assigned To Processing Team",
    progressCompleted: 65,
    progressColor: "!bg-inProcess",
  },
  PAYMENT_VERIFICATION_UNDER_PROCESS: {
    value: "Payment Under Verification",
    progressCompleted: 45,
    progressColor: "!bg-inProcess",
  },
  AWAITING_FULL_PAYMENT: {
    value: "Awaiting full payment",
    progressCompleted: 35,
    progressColor: "!bg-error",
  },
  DOCUMENT_VERIFICATION_UNDER_PROCESS: {
    value: "Documents Under Verification",
    progressCompleted: 35,
    progressColor: "!bg-inProcess",
  },
  REQUIRE_MORE_DOCUMENTS: {
    value: "Awaiting Documents",
    progressCompleted: 35,
    progressColor: "!bg-error",
  },
  AWAITING_PAYMENT: {
    value: "Awaiting Payment",
    progressCompleted: 10,
    progressColor: "!bg-error",
  },
  UNDER_PROCESS: {
    value: "Under Process",
    progressCompleted: 10,
    progressColor: "!bg-inProcess",
  },
  INITIATE_REFUND: {
    value: "Refund Initiated",
    progressCompleted: 10,
    progressColor: "!bg-error",
  },
  REFUND_COMPLETED: {
    value: "Refund Completed",
    progressCompleted: 100,
    progressColor: "bg-primary-200",
  },
  PAYMENT_VERIFICATION_ON_HOLD: {
    value: "Payment Verification On Hold",
    progressCompleted: 100,
    progressColor: "bg-primary-200",
  },
};

export default TX_PROGRESS;

export const hop_benefits = [
  {
    benefit:`Live Exchange  \n Rates`,
    image:coinswap,
  },
  {
    benefit:"Real Time Tracking",
    image:tracking,
  },
  {
    benefit:"Fast and Secure",
    image:secure,
  },
  {
    benefit:"Fee Transparency",
    image:fee,
  },
  {
    benefit:"Live Commission Calculation",
    image:commission,
  },
  {
    benefit:"Digital Process",
    image:process,
  }
]
